import script from "./PettyCashTable.vue?vue&type=script&setup=true&lang=js"
export * from "./PettyCashTable.vue?vue&type=script&setup=true&lang=js"

import "./PettyCashTable.vue?vue&type=style&index=0&id=155fddc6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-155fddc6"]])

export default __exports__